import { getCallSessionAgentUserId } from "../api";
import { callAPi } from "../CallService";
import {
  getAgentPhoneForCalling,
  getAgentPhoneForCallingKrmId
} from "../helpers";

export const getApiParams = (callFlow, agent) => {
  let num = getAgentPhoneForCalling(agent);
  if (!num || num === "-") {
    num = "";
  }
  const data = {
    uuid: callFlow.state.callEvent["uuid"],
    number: num,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: callFlow.ticker.firstCallAnswerEvent["unique_id"],
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };

  return data;
};

export const getApiParamsCancel = (callFlow, agent) => {
  let num = getAgentPhoneForCalling(agent);
  if (!num || num === "-") {
    num = "";
  }
  const data = {
    uuid: (sessionStorage.getItem('legcuuid') || callFlow.state.callEvent["unique_id"]),
    number: num,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: (sessionStorage.getItem('legcuuid') || callFlow.state.callEvent["unique_id"]),
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };

  return data;
};

export const getApiParamsHoldUnHold = (callFlow, agent) => {
  const data = {
    uuid: callFlow.state.callEvent["uuid"],
    number: "",
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    args: callFlow.ticker.callEvent["uuid"] + '@@' + sessionStorage.getItem('legcuuid'),
    queue_id: null,
    knumber: callFlow.state.callEvent["knowlarity_number"],
  };

  return data;
};

export const getApiParamsForTransfer = (callFlow, agent) => {
  const data = {
    user_id: getCallSessionAgentUserId(),
    cm_access_key: null,
    freeswitch: callFlow.state.callEvent["FreeSWITCH_IPv4"],
    uuid: callFlow.ticker.firstCallAnswerEvent["unique_id"],
    ivr_display_number: callFlow.state.callEvent["knowlarity_number"],
    to: getAgentPhoneForCallingKrmId(agent),
    queue_id: callFlow.state.callEvent["variable_cc_queue"]
      ? callFlow.state.callEvent["variable_cc_queue"]
      : null,
  };

  return data;
};

export const ibd = {
  CALL_ACTIONS: {
    TRANSFER_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_xfer";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
      return response;
    },
    CONFERENCE_CALL: async (callFlow, agent) => {
      const data1 = getApiParams(callFlow, agent);
      data1["type"] = "att_conf";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
      return response;
    },

    CONFERENCE_CALL_CANCEL: async (callFlow, agent) => {
      const data1 = getApiParamsCancel(callFlow, agent);
      data1["type"] = "conference_kick";
      let data = new FormData();
      Object.keys(data1).map((key) => {
        data.append(key, data1[key]);
      });
      const response = await callAPi(
        "/newsr/sr_conference/conference_call/",
        "POST",
        data
      );
      return response;
    },

    CONFERENCE_HOLD: async (callFlow, agent) => {
      //if (!callFlow.ticker.is_bdtmf) {
      if (
        (callFlow.state.call_type != "legc_call" &&
          !callFlow.ticker.is_bdtmf) ||
        (callFlow.state.call_type === "legc_call" &&
          callFlow.state.callEvent["variable_current_application"] !=
            "att_xfer" &&
          callFlow.state.callEvent["variable_current_application"] !=
            "conference")
      ) {
        const data1 = getApiParamsForTransfer(callFlow, agent);
        data1["type"] = "hold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_callcenter/transfer_call/",
          "POST",
          data
        );
        return response;
      } else {
        const data1 = getApiParamsHoldUnHold(callFlow, agent);
        data1["type"] = "conference_hold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_conference/conference_call/",
          "POST",
          data
        );
        return response;
      }
    },
    CONFERENCE_UNHOLD: async (callFlow, agent) => {
      if (
        (callFlow.state.call_type !== "legc_call" &&
          !callFlow.ticker.is_bdtmf) ||
        (callFlow.state.call_type === "legc_call" &&
          callFlow.state.callEvent["variable_current_application"] !==
            "att_xfer" &&
          callFlow.state.callEvent["variable_current_application"] !==
            "conference")
      ) {
        const data1 = getApiParamsForTransfer(callFlow, agent);
        data1["type"] = "unhold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_callcenter/transfer_call/",
          "POST",
          data
        );
        return response;
      } else {
        const data1 = getApiParamsHoldUnHold(callFlow, agent);
        data1["type"] = "conference_unhold";

        let data = new FormData();
        Object.keys(data1).map((key) => {
          data.append(key, data1[key]);
        });

        const response = await callAPi(
          "/newsr/sr_conference/conference_call/",
          "POST",
          data
        );
        return response;
      }
    },
    AGENT_LIST_API: async (callFlow, params) => {
      return await callAPi("/newsr/api/v1/warm_call_agents/", "GET", params);
    },
  },
};
